import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { ParentAssessmentManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/parent-assessments/$slug")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <ParentAssessmentManagement />
    </RouteGuard>
  ),
});
